import React, {useState} from "react";

interface BYAsyncButtonProps {
    className?: string;
    type?: "button" | "submit" | "reset";
    disabled?: boolean;
    onClick: () => Promise<any>;
}

const BYAsyncButton: React.FC<BYAsyncButtonProps> = (props) => {
    const {className = '', type = 'button', disabled = false, onClick, children} = props;
    const [loading, setLoading] = useState(false);

    return <button
        className={className}
        type={type}
        disabled={disabled || loading}
        onClick={() => {
            setLoading(true);
            onClick().finally(() => {
                if (setLoading) {
                    setLoading(false);
                }
            });
        }}
    >
        {children}
        {loading && <div className="spinner-grow spinner-grow-sm ml-1 color-green" role="status">
            <span className="sr-only">Loading...</span>
        </div>}
    </button>;
};

export default BYAsyncButton;
